// semeia-disable-reexport
import Specialty from "parog-web/models/core-specialty";
/**
 * Created with import_specialties.rb (in tasks/scripts).
 */
const Specialties = [
  new Specialty({
    id: "doctor",
    codes: [
      "G15_10",
      "G15_10/SM26",
      "G15_10/SM53",
      "G15_10/SM54",
      "G15_10/SCH37",
      "G16_10",
      "G15_10/CAPA12"
    ]
  }),

  new Specialty({
    id: "resuscitator-doctor",
    codes: [
      "G15_10/SM02",
      "G15_10/SM46",
      "G15_10/SCH02",
      "G15_10/SCH57",
      "G15_10/C03",
      "G15_10/C39",
      "G15_10/DSM233"
    ]
  }),

  new Specialty({
    id: "cardiologist",
    codes: [
      "G15_10/SM04",
      "G15_10/SCH09",
      "G15_10/C07",
      "G15_10/C34",
      "G15_10/CAPA04"
    ]
  }),

  new Specialty({
    id: "vascular-doctor",
    codes: ["G15_10/SM61", "G15_10/DSM223"]
  }),

  new Specialty({
    id: "surgeon",
    codes: ["G15_10/SM05", "G15_10/SCH10", "G15_10/SCH16", "G15_10/SCH18"]
  }),

  new Specialty({
    id: "dermatologist",
    codes: ["G15_10/SM15", "G15_10/SCH19", "G15_10/C15", "G15_10/DSM211"]
  }),

  new Specialty({
    id: "radiologist",
    codes: ["G15_10/SCH55", "G15_98", "G15_10/SCH22"]
  }),

  new Specialty({
    id: "gynecologist",
    codes: [
      "G15_10/SM19",
      "G15_10/SM20",
      "G15_10/SM51",
      "G15_10/SM52",
      "G15_10/SM72",
      "G15_10/CEX22",
      "G15_10/CEX24",
      "G15_10/CEX26",
      "G15_10/SCH26",
      "G15_10/C23",
      "G15_10/C25",
      "G15_10/C27"
    ]
  }),

  new Specialty({
    id: "gastroenterologist",
    codes: ["G15_10/SM24", "G15_10/SCH23", "G15_10/C29"]
  }),

  new Specialty({
    id: "internal-medicine-doctor",
    codes: ["G15_10/SM27", "G15_10/SCH39"]
  }),

  new Specialty({
    id: "neuro-surgeon",
    codes: ["G15_10/SM31", "G15_10/SCH44", "G15_10/C45"]
  }),

  new Specialty({
    id: "otolaryngologist",
    codes: ["G15_10/SM39", "G15_10/SCH48"]
  }),

  new Specialty({
    id: "pediatrician",
    codes: ["G15_10/SM40", "G15_10/SCH50", "G15_10/C51"]
  }),

  new Specialty({
    id: "pulmonologist",
    codes: ["G15_10/SM41", "G15_10/SCH53", "G15_10/C54"]
  }),

  new Specialty({
    id: "rheumatologist",
    codes: ["G15_10/SM48", "G15_10/SCH58", "G15_10/C62"]
  }),

  new Specialty({
    id: "ophtalmologist",
    codes: ["G15_10/SM38", "G15_10/SCH47"]
  }),

  new Specialty({
    id: "urological-surgeon",
    codes: ["G15_10/SM12", "G15_10/SCH17"]
  }),

  new Specialty({
    id: "neuro-psychiatrist",
    codes: ["G15_10/SM33", "G15_10/C47"]
  }),

  new Specialty({
    id: "stomatologist",
    codes: ["G15_10/SM07", "G15_10/SM50", "G15_10/SM56", "G15_10/SCH59"]
  }),

  new Specialty({
    id: "dentist",
    codes: ["G15_40/SCD02", "G15_10/SCH46", "G15_40", "G15_40/SCD03", "G16_40"]
  }),

  new Specialty({
    id: "midwife",
    codes: ["G15_50", "G16_50"]
  }),

  new Specialty({
    id: "nurse",
    codes: ["G15_60", "G15_69"]
  }),

  new Specialty({
    id: "physiotherapist",
    codes: ["G15_70"]
  }),

  new Specialty({
    id: "chiropodist",
    codes: ["G15_80"]
  }),

  new Specialty({
    id: "speech-therapist",
    codes: ["G15_91"]
  }),

  new Specialty({
    id: "orthoptist",
    codes: ["G15_92"]
  }),

  new Specialty({
    id: "medical-biologist",
    codes: [
      "G15_10/SM03",
      "G15_10/SM63",
      "G15_10/SM64",
      "G15_10/SCH06",
      "G15_10/SM65",
      "G15_10/SM66",
      "G15_10/SM67"
    ]
  }),

  new Specialty({
    id: "biologist",
    codes: [
      "G15_10/DSM204",
      "G15_10/SCH05",
      "G15_10/DSM205",
      "G15_10/SCH04",
      "G15_10/SCH49",
      "G15_10/DSM203"
    ]
  }),

  new Specialty({
    id: "physical-medicine-doctor",
    codes: ["G15_10/SM29", "G15_10/SCH42", "G15_10/C60"]
  }),

  new Specialty({
    id: "neurologist",
    codes: ["G15_10/SM32", "G15_10/SCH45", "G15_10/C43"]
  }),

  new Specialty({
    id: "psychiatrist",
    codes: [
      "G15_10/SM42",
      "G15_10/SCH54",
      "G15_10/C57",
      "G15_10/C58",
      "G15_10/DSM231"
    ]
  }),

  new Specialty({
    id: "child-psychiatrist",
    codes: ["G15_10/SM43"]
  }),

  new Specialty({
    id: "geriatrician",
    codes: ["G15_10/SM18", "G15_10/SCH38", "G15_10/CAPA06", "G15_10/DSM213"]
  }),

  new Specialty({
    id: "nephrologist",
    codes: ["G15_10/SM30", "G15_10/SCH43", "G15_10/C30"]
  }),

  new Specialty({
    id: "anatomy-cytology-pathology-doctor",
    codes: ["G15_10/SM01", "G15_10/SCH01", "G15_10/C01"]
  }),

  new Specialty({
    id: "ortho-surgeon",
    codes: ["G15_10/SM08", "G15_10/SCH14", "G15_10/C12"]
  }),

  new Specialty({
    id: "diabetologist-endocrinologist",
    codes: [
      "G15_10/SM16",
      "G15_10/SM62",
      "G15_10/SCH20",
      "G15_10/C37",
      "G15_10/C75"
    ]
  }),

  new Specialty({
    id: "pediatric-surgeon",
    codes: [
      "G15_10/SM09",
      "G15_10/SM69",
      "G15_10/SM70",
      "G15_10/SCH12",
      "G15_10/C68"
    ]
  }),

  new Specialty({
    id: "maxillofacial-surgeon",
    codes: ["G15_10/SM06", "G15_10/SM68", "G15_10/SCH13", "G15_10/C10"]
  }),

  new Specialty({
    id: "plastic-surgeon",
    codes: ["G15_10/SM10", "G15_10/SCH15", "G15_10/C09", "G15_10/DSM208"]
  }),

  new Specialty({
    id: "cardiac-surgeon",
    codes: ["G15_10/SM11", "G15_10/SM13", "G15_10/DSM209"]
  }),

  new Specialty({
    id: "visceral-digestive-surgeon",
    codes: ["G15_10/SM14", "G15_10/SCH11"]
  }),

  new Specialty({
    id: "retail-pharmacist",
    codes: [
      "G15_21",
      "G15_21/A",
      "G15_21/D",
      "G15_21/DA",
      "G15_21/DM",
      "G15_21/E",
      "G15_21/EA",
      "G15_21/ED",
      "G15_39",
      "G16_21"
    ]
  }),

  new Specialty({
    id: "hematologist",
    codes: [
      "G15_10/SM21",
      "G15_10/SM22",
      "G15_10/SM23",
      "G15_10/SM71",
      "G15_10/SCH27",
      "G15_10/SCH28",
      "G15_10/C38",
      "G15_10/DSM214",
      "G15_10/DSM215"
    ]
  }),

  new Specialty({
    id: "nuclear-medicine-doctor",
    codes: ["G15_10/SM28", "G15_10/SCH41", "G15_10/C69", "G15_10/DSM222"]
  }),

  new Specialty({
    id: "oncologist",
    codes: [
      "G15_10/SM35",
      "G15_10/SM36",
      "G15_10/SCH08",
      "G15_10/C35",
      "G15_10/DSM206",
      "G15_10/DSM236",
      "G15_10/DSM237",
      "G15_10/DSM238",
      "G15_10/DSM239",
      "G15_10/DSM240"
    ]
  }),

  new Specialty({
    id: "radiotherapist",
    codes: [
      "G15_10/SM37",
      "G15_10/SM44",
      "G15_10/SM45",
      "G15_10/SM55",
      "G15_10/SCH56"
    ]
  }),

  new Specialty({
    id: "tropical-disease-doctor",
    codes: [
      "G15_10/SM58",
      "G15_10/SCH33",
      "G15_10/C31",
      "G15_10/CAPA13",
      "G15_10/DSM228"
    ]
  }),

  new Specialty({
    id: "forensic-doctor",
    codes: [
      "G15_10/SM60",
      "G15_10/SCH40",
      "G15_10/C40",
      "G15_10/CAPA14",
      "G15_10/DSM221"
    ]
  }),

  new Specialty({
    id: "emergency-doctor",
    codes: [
      "G15_10/SM59",
      "G15_10/SCH36",
      "G15_10/CAPA02",
      "G15_10/DSM220",
      "G15_10/CAPA09"
    ]
  }),

  new Specialty({
    id: "allergist",
    codes: ["G15_10/SM57", "G15_10/C33", "G15_10/CAPA03", "G15_10/DSM201"]
  }),

  new Specialty({
    id: "ipa",
    codes: ["G15_60/SI01", "G15_60/SI02", "G15_60/SI03", "G15_60/SI04"]
  }),

  new Specialty({
    id: "occupational-physician",
    codes: ["G15_10/SM25", "G15_10/SCH35", "G15_10/C41", "G15_10/CAPA11"]
  }),

  new Specialty({
    id: "orl-surgeon",
    codes: ["G15_10/SM34", "G15_10/C83", "G15_10/DSM207"]
  }),

  new Specialty({
    id: "hemobiologist",
    codes: ["G15_10/SCH29", "G15_10/C20", "G15_10/CAPA15", "G15_10/DSM216"]
  }),

  new Specialty({
    id: "urologist",
    codes: ["G15_10/CEX64", "G15_10/C13"]
  }),

  new Specialty({
    id: "reproductive-medicine-doctor",
    codes: ["G15_10/SCH34", "G15_10/DSM218"]
  }),

  new Specialty({
    id: "hospital-pharmacist",
    codes: ["G15_10/SCH51", "G15_21/EH", "G15_21/H", "G15_21/M", "G15_38"]
  }),

  new Specialty({
    id: "sports-medicine-doctor",
    codes: ["G15_10/C05", "G15_10/CAPA10", "G15_10/DSM219"]
  }),

  new Specialty({
    id: "thoracic-surgeon",
    codes: ["G15_10/C11"]
  }),

  new Specialty({
    id: "diabetologist",
    codes: ["G15_10/C36"]
  }),

  new Specialty({
    id: "phoniatrist",
    codes: ["G15_10/C52"]
  }),

  new Specialty({
    id: "orthodentist",
    codes: ["G15_10/C76", "G15_10/DSM227", "G15_40/SCD01"]
  }),

  new Specialty({
    id: "addictologist",
    codes: ["G15_10/CAPA01", "G15_10/CAPA16", "G15_10/DSM200"]
  }),

  new Specialty({
    id: "pain-medicine-doctor",
    codes: ["G15_10/CAPA05", "G15_10/DSM235"]
  }),

  new Specialty({
    id: "andrologist",
    codes: ["G15_10/DSM202"]
  }),

  new Specialty({
    id: "neonatalogist",
    codes: ["G15_10/DSM224"]
  }),

  new Specialty({
    id: "neuropathologist",
    codes: ["G15_10/DSM225"]
  }),

  new Specialty({
    id: "nutritionist",
    codes: ["G15_10/DSM226"]
  }),

  new Specialty({
    id: "radio-pharmacist",
    codes: ["G15_10/DSM232"]
  }),

  new Specialty({
    id: "biologist-pharmacist",
    codes: ["G15_21/EG", "G15_21/G"]
  }),

  new Specialty({
    id: "audioprosthesist",
    codes: ["G15_26"]
  }),

  new Specialty({
    id: "optician",
    codes: ["G15_28"]
  }),

  new Specialty({
    id: "dental-assistant",
    codes: ["G15_31"]
  }),

  new Specialty({
    id: "care-giver",
    codes: ["G15_35"]
  }),

  new Specialty({
    id: "ambulance-driver",
    codes: ["G15_36"]
  }),

  new Specialty({
    id: "child-care-assistant",
    codes: ["G15_37"]
  }),

  new Specialty({
    id: "orthoprosthetist",
    codes: ["G15_81"]
  }),

  new Specialty({
    id: "podiatrist",
    codes: ["G15_82"]
  }),

  new Specialty({
    id: "orthopedist",
    codes: ["G15_83"]
  }),

  new Specialty({
    id: "ocularist",
    codes: ["G15_84"]
  }),

  new Specialty({
    id: "epithesist",
    codes: ["G15_85"]
  }),

  new Specialty({
    id: "occupational-therapist",
    codes: ["G15_94"]
  }),

  new Specialty({
    id: "dietitian",
    codes: ["G15_95"]
  }),

  new Specialty({
    id: "psychomotrician",
    codes: ["G15_96"]
  }),

  new Specialty({
    id: "geneticist",
    codes: [
      "G15_10/SM17",
      "G15_10/SCH24",
      "G15_10/SCH25",
      "G15_10/C72",
      "G15_10/DSM210"
    ]
  }),

  new Specialty({
    id: "public-health-doctor",
    codes: ["G15_10/SM49", "G15_10/SCH21"]
  }),

  new Specialty({
    id: "immunologist",
    codes: ["G15_10/SCH31", "G15_10/SCH32", "G15_10/DSM217"]
  }),

  new Specialty({
    id: "thermal-doctor",
    codes: ["G15_10/C71"]
  }),

  new Specialty({
    id: "social-worker",
    codes: ["S0_social-worker"]
  }),

  new Specialty({
    id: "psychologist",
    codes: ["S0_psychologist"]
  })
];

export { Specialties };
